import React, { Component } from 'react'
import Axios from 'axios'
import './new-student-form.css'
import { Helmet } from 'react-helmet'
import { baseUrl } from '../assets/Animations'

class NewStudentFormWithSecurity extends Component {
    constructor() {
        super()
        this.state = {
            card: 0,
            studentArray: [{id: 'input1'}],
            school: '',
            abbreviation: '',
            website: '',
            logoName: '',
            email: '',
            referral: false,
            valid: true
        }
    }
    componentDidMount = () => {
        document.getElementById('new-student-form-card-' + this.state.card).style.display= "block"
        document.getElementById('new-student-form-card-' + this.state.card).style.transition= "opacity 1000ms"
        setTimeout(function() {
            if(document.getElementById('new-student-form-card-' + this.state.card)) {
                document.getElementById('new-student-form-card-' + this.state.card).style.opacity= "1"
            }
        }.bind(this),0)
        this.setTheSchool()
        this.checkIfLinkIsValid()
    }
    componentDidUpdate = () => {
            setTimeout(function() {
                if(document.getElementById('new-student-form-card-' + this.state.card)) {
                    document.getElementById('new-student-form-card-' + this.state.card).style.display= "block"
                }
            }.bind(this), 200)
            setTimeout(function() {
                if(document.getElementById('new-student-form-card-' + this.state.card)) {
                    document.getElementById('new-student-form-card-' + this.state.card).style.transition= "margin-left 1000ms, opacity 1000ms"
                    document.getElementById('new-student-form-card-' + this.state.card).style.marginLeft= "50%"
                    document.getElementById('new-student-form-card-' + this.state.card).style.opacity= "1"
                }
            }.bind(this), 250)
    }

    //MAKE SURE CUSTOMER HASN'T ALREADY USED THE LINK
    checkIfLinkIsValid = async () => {
        Axios.get(`${baseUrl}/validatestudentform/${this.props.location.pathname.slice(16)}`)
        .then(res => {
            if(res.status === 201) {
                this.setState({valid: true})
            } else {
                this.setState({valid: false}) 
            }
        })
        .catch(err => {
            this.setState({valid: false})
        })
    }
    //-----------------------------------------------

    setTheSchool = () => {
        let url = window.location.href
        let trimmed = url.substring(8)
        let name = trimmed.split('.')[0]
        if(name === 'mountainside') {
            this.setState({
                school: 'Mountainside Music Academy',
                abbreviation: 'MMA',
                website: 'https://www.mountainsidemusicacademy.com',
                logoName: 'mmalogo.png',
                email: 'info@mountainsidemusicacademy.com'
            })
        } else if (name === 'lakeside') {
            this.setState({
                school: 'Lakeside Music Academy',
                abbreviation: 'LSMA',
                website: 'https://www.lakesidemusicacademy.com',
                logoName: "lakesidelogo.png",
                email: 'info@lakesidemusicacademy.com'
            })
        } else if (name === 'treeside') {
            this.setState({
                school: 'Treeside Music Academy',
                abbreviation: 'TMA',
                website: 'https://www.treesidemusicacademy.com',
                logoName: 'treesidelogo.png',
                email: 'info@treesidemusicacademy.com'
            })
        } else if (name === 'greatlakes') {
            this.setState({
                school: 'Great Lakes Music Academy',
                abbreviation: 'GLMA',
                website: 'https://www.greatlakesmusicacademy.com',
                logoName: 'greatlakeslogo.png',
                email: 'info@greatlakesmusicacademy.com'
            })    
        }
    }
    changeCard = (direction) => {
        let theCard = this.state.card
        if(direction === 'forward') {
            let theOldCard = this.state.card
            document.getElementById('new-student-form-card-' + this.state.card).style.transition= "margin-left 1000ms, opacity 1000ms"
            document.getElementById('new-student-form-card-' + this.state.card).style.marginLeft= "-1000px"
            //document.getElementById('new-student-form-card-' + this.state.card).style.display= "none"
            setTimeout(function() {
                document.getElementById('new-student-form-card-' + theOldCard).style.marginLeft= "50%"
                document.getElementById('new-student-form-card-' + theOldCard).style.display= "none"
            },1000)
            this.setState ({
                card: theCard + 1
            })
        } else if (direction === 'last') {
            window.location.href = this.state.website
        } else {
            let lastCard = this.state.card - 1
            let currentCard = this.state.card
            document.getElementById('new-student-form-card-' + lastCard).style.marginLeft= "-1000px"
            document.getElementById('new-student-form-card-' + this.state.card).style.transition= "opacity 700ms"
            document.getElementById('new-student-form-card-' + this.state.card).style.opacity= "0"
            setTimeout(function() {
                document.getElementById('new-student-form-card-' + currentCard).style.display= "none"
            }, 800)
            this.setState ({
                card: theCard - 1
            })
        }
    }
    setNumberOfStudents = (num) => {
        let counterArray = []
        let counter = 0
        //COLOR RESET
        for(let i = 1; i < 6; i++) {
            document.getElementById("new-student-form-number-box-" + i).style.color = "rgb(146, 146, 146)"
            document.getElementById("new-student-form-number-box-" + i).style.border = "2px solid rgb(146, 146, 146)" 
            document.getElementById("new-student-form-number-box-" + i).style.backgroundColor = "rgba(0, 0, 0, 0)" 
        }
        //SET THE COLOR
        document.getElementById("new-student-form-number-box-" + num).style.color = "#000"
        document.getElementById("new-student-form-number-box-" + num).style.border = "2px solid #000"
        document.getElementById("new-student-form-number-box-" + num).style.backgroundColor = "rgba(0, 104, 17, 0.767)"
        for(let i = 0; i < num; i++) {
            let emptyObj = {id: `input${counter + 1}`}
            counter ++
            counterArray.push(emptyObj)
        }
        this.setState ({
            studentArray: counterArray
        })
    }
    
    sendTheStudent = () => {
        let trimmedFamilyId = this.props.location.pathname.slice(16)
        if(trimmedFamilyId.slice(-1) === '/') {
            trimmedFamilyId = trimmedFamilyId.substring(0, trimmedFamilyId.length - 1)
        }
        let ref = this.state.referral ? `${document.getElementById('new-student-form-how').value}` : ''
        let newStudent = {
        //SET FAMILYID AS THE PARAM FROM THE LINK
            familyId: trimmedFamilyId,
        //--------------------------------------------
            familyName: document.getElementById('new-student-form-last-name').value,
            students: [],
            address: {
              addressLine1: document.getElementById('new-student-form-address').value,
              addressLine2: '',
              city: document.getElementById('new-student-form-city').value,
              state: document.getElementById('new-student-form-state').value,
              zipcode: parseInt(document.getElementById('new-student-form-zip').value)
            },
            primaryParentName: document.getElementById('new-student-form-parents-name').value,
            secondaryParentName: '',
            school: `${this.state.abbreviation}`,
            primaryEmail: document.getElementById('new-student-form-email').value,
            secondaryEmail: '',
            primaryCellphone: document.getElementById('new-student-form-cell').value,
            secondaryCellphone: '',
            primaryHomePhone: document.getElementById('new-student-form-home').value,
            secondaryHomePhone: '',
            familyStatus: 'Being Onboarded',
            hearOfUs: document.getElementById('how-you-hear').value,
            onboardDate: Date(),
            schoolEmail: `${this.state.email}`,
            virtual: document.getElementById('virtual-lesson').checked,
            inHome: document.getElementById('inhome-lesson').checked,
            availability: document.getElementById('new-student-form-avail').value,
            referral: ref,
          }

        let theStudents = this.state.studentArray
        for(let i = 0; i < theStudents.length; i++) {
            let studentToPush = {}

            studentToPush.studentId = Math.random().toString(16).slice(2)
            studentToPush.studentName = document.getElementById('nameinput-' + theStudents[i].id).value
            studentToPush.dob = document.getElementById('dateinput-' + theStudents[i].id).value
            studentToPush.instrument = document.getElementById('instinput-' + theStudents[i].id).value
            studentToPush.teachersId = ''
            studentToPush.lessonLength = 0
            studentToPush.lessonRate = 0
            studentToPush.allRates = {15: 26, 30: 49, 45: 64, 60: 79}
            studentToPush.studentStatus = 'Being Onboarded'
            studentToPush.studentNotes = ''

            newStudent.students.push(studentToPush)
        }
        Axios.all([
            Axios.put(`${baseUrl}/submitnewstudentform`, {
                newStudent: newStudent
            }),
            Axios.put(`${baseUrl}/studentinfobackup`, {
                newStudent: newStudent
            })
            .then(response => {
                //console.log(response)
            })
            .catch(e => {
                console.log('ooops')
                console.log(e)
            })
        ])
        this.changeCard('forward')
    }
    handleChange = (value) => {
        if(value === 'referral') {
            this.setState({
                referral: true
            })
        } else {
            this.setState({
                referral: false
            })
        }
    }

    render() {
        if(this.state.valid) {
            return(
                <>
                    <Helmet>
                        <title>{`${this.state.school} New Student`}</title>
                    </Helmet>
                    <div className="new-student-form-background" style={{backgroundImage: `url(./${this.state.abbreviation}.jpg)`}}>
                        <div className="new-student-form-card" id="new-student-form-card-0">
                            <div className="new-student-form-card-counter">1/6</div>
                            <div className="new-student-form-card-contents">
                                <div className="new-student-form-card-logo" style={{backgroundImage: `url(./${this.state.logoName})`}}></div>
                                <div className="new-student-form-card-title">Welcome to {this.state.school}!</div>
                                <div className="new-student-form-card-subtitle">We have a few questions for you, it should take about <strong>2 minutes</strong>.</div>
                            </div>
                            <div className="new-student-form-btn-wrapper">
                                <div className="new-student-form-btn first-card-btn" onClick={() => this.changeCard('forward')}>NEXT</div>
                            </div>
                        </div>
                        <div className="new-student-form-card" id="new-student-form-card-1">
                            <div className="new-student-form-card-counter">2/6</div>
                            <div className="new-student-form-card-contents">
                            <div className="new-student-form-card-subtitle card-2-subtitle">How many students would you like to sign up?</div>
                                <div className="new-student-form-number-wrapper">
                                    <div className="new-student-form-number-box" id="new-student-form-number-box-1" onClick={() => this.setNumberOfStudents(1)}>1</div>
                                    <div className="new-student-form-number-box" id="new-student-form-number-box-2" onClick={() => this.setNumberOfStudents(2)}>2</div>
                                    <div className="new-student-form-number-box" id="new-student-form-number-box-3" onClick={() => this.setNumberOfStudents(3)}>3</div>
                                    <div className="new-student-form-number-box" id="new-student-form-number-box-4" onClick={() => this.setNumberOfStudents(4)}>4</div>
                                    <div className="new-student-form-number-box" id="new-student-form-number-box-5" onClick={() => this.setNumberOfStudents(5)}>5</div>
                                </div>
                            </div>
                            <div className="new-student-form-btn-wrapper">
                                <div className="new-student-form-btn" onClick={() => this.changeCard('forward')}>NEXT</div>
                            </div>
                        </div>
                        <div className="new-student-form-card" id="new-student-form-card-2">
                            <div className="flip-screen-beethoven">
                                <div className="beethoven-picture"></div>
                                <div className="new-student-form-flip-screen-warning">Please flip you phone horizontal!</div>
                            </div>
                            <div className="new-student-form-card-counter third-card-flip-warning">3/6</div>
                            <div className="new-student-form-card-contents third-card-flip-warning">
                            <div className="new-student-form-card-subtitle card-3-subtitle">
                                Student Information
                            </div>
                            {this.state.studentArray.map((each) => {
                                return <div className="each-student-input-wrapper" key={each.id}>
                                            <div className="new-student-form-each-student-input-wrapper">
                                                <label className="each-student-input-labels">Student's First Name</label>
                                                <input className="new-student-form-student-input" id={'nameinput-' + each.id} />
                                            </div>
                                            <div className="new-student-form-each-student-input-wrapper">
                                                <label className="each-student-input-labels">Instrument</label>
                                                <input className="new-student-form-student-input" id={'instinput-' + each.id} />
                                            </div>
                                            <div className="new-student-form-each-student-input-wrapper">
                                                <label className="each-student-input-labels">D.O.B.</label>
                                                <input className="new-student-form-student-input" id={'dateinput-' + each.id} type="date" />
                                            </div>
                                        </div>
                            })}
                            </div>
                            <div className="new-student-form-btn-wrapper third-card-flip-warning">
                                <div className="new-student-form-back-btn" onClick={() => this.changeCard('back')}>BACK</div>
                                <div className="new-student-form-btn" onClick={() => this.changeCard('forward')}>NEXT</div>
                            </div>
                        </div>
                        <div className="new-student-form-card" id="new-student-form-card-3">
                            <div className="flip-screen-beethoven">
                                <div className="beethoven-picture"></div>
                                <div className="new-student-form-flip-screen-warning">Please flip you phone horizontal!</div>
                            </div>
                            <div className="new-student-form-card-counter third-card-flip-warning">4/6</div>
                            <div className="new-student-form-card-contents third-card-flip-warning">
                                <div className="new-student-form-card-subtitle card-4-subtitle">
                                    Family Contact Information
                                </div>
                                <div className="card-body">
                                    <div className="input-label-wrapper">
                                        <label className="new-input-label">Student's Last Name</label>
                                        <input className="new-input-bar" id='new-student-form-last-name' placeholder="Last Name"/>
                                    </div>
                                    <div className="input-label-wrapper">
                                        <label className="new-input-label">Parent First Name(s)</label>
                                        <input className="new-input-bar" id='new-student-form-parents-name' placeholder="Parent First Name(s)"/>
                                    </div>
                                    <div className="input-label-wrapper">
                                        <label className="new-input-label">Address</label>
                                        <input className="new-input-bar" id='new-student-form-address' placeholder="123 Main St" />
                                    </div>
                                    <div className="input-label-wrapper">
                                        <label className="new-input-label">City</label>
                                        <input className="new-input-bar" id='new-student-form-city' placeholder="Boulder" />
                                    </div>
                                    <div className="input-label-wrapper">
                                        <label className="new-input-label">State</label>
                                        <input className="new-input-bar" id='new-student-form-state' placeholder="Colorado" />
                                    </div>
                                    <div className="input-label-wrapper">
                                        <label className="new-input-label">Zip</label>
                                        <input className="new-input-bar" id='new-student-form-zip' placeholder="80301" />
                                    </div>
                                    <div className="input-label-wrapper">
                                        <label className="new-input-label">Email</label>
                                        <input className="new-input-bar" id='new-student-form-email' placeholder="example@email.com" />
                                    </div>
                                    <div className="input-label-wrapper">
                                        <label className="new-input-label">Cell Phone #</label>
                                        <input className="new-input-bar" id='new-student-form-cell' placeholder="123-555-1234" />
                                    </div>
                                    <div className="input-label-wrapper">
                                        <label className="new-input-label">Home Phone #</label>
                                        <input className="new-input-bar" id='new-student-form-home' placeholder="123-555-1234"/>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="new-student-form-btn-wrapper third-card-flip-warning">
                                <div className="new-student-form-back-btn" onClick={() => this.changeCard('back')}>BACK</div>
                                <div className="new-student-form-btn" onClick={() => this.changeCard('forward')}>NEXT</div>
                            </div>
                        </div>
                        <div className="new-student-form-card" id="new-student-form-card-4">
                            <div className="new-student-form-card-counter">5/6</div>
                            <div className="new-student-form-card-contents">
                            <div className="new-student-form-card-subtitle type-lesson">What type of lessons?</div>
                            <div className="lessons-type-wrapper">
                                <div className="lessons-type-checkbox-wrapper">
                                    <input className="lessons-type-checkbox" type="checkbox" id="inhome-lesson" />
                                    <label>In-home</label>
                                </div>
                                <div className="lessons-type-checkbox-wrapper">
                                    <input className="lessons-type-checkbox" type="checkbox" id="virtual-lesson" />
                                    <label>Virtual</label>
                                </div>
                            </div>
                                <div className="new-student-form-card-subtitle">Describe your availability</div>
                                <textarea className="last-card-input second-to-last" id="new-student-form-avail" placeholder="We're available..." />
                            </div>
                            <div className="new-student-form-btn-wrapper">
                            <div className="new-student-form-back-btn" onClick={() => this.changeCard('back')}>BACK</div>
                            <div className="new-student-form-btn" onClick={() => this.changeCard('forward')}>NEXT</div>
                            </div>
                        </div>
                        <div className="new-student-form-card" id="new-student-form-card-5">
                            <div className="new-student-form-card-counter">6/6</div>
                            <div className="new-student-form-card-contents">
                            <div className="new-student-form-card-title last-card-title">One last question...</div>
                                <div className="new-student-form-card-subtitle">How did you hear about us?</div>
                                <div className="how-you-hear-selector-wrapper">
                                    <select id="how-you-hear" className="how-you-hear-selector" onChange={(e) => this.handleChange(e.target.value)}>
                                        <option value="-">Select</option>
                                        <option value="google">Google</option>
                                        <option value="facebook">Facebook</option>
                                        <option value="lessons.com">Lessons.com</option>
                                        <option value="craigslist">Craigslist</option>
                                        <option value="referral">Referral</option>
                                    </select>
                                </div>
                                {this.state.referral && <textarea className="last-card-input" id="new-student-form-how" placeholder="Care to share?" />}
                            </div>
                            <div className="new-student-form-btn-wrapper">
                            <div className="new-student-form-back-btn" onClick={() => this.changeCard('back')}>BACK</div>
                            <div className="new-student-form-btn" onClick={() => this.sendTheStudent()}>Finish</div>
                            </div>
                        </div>
                        <div className="new-student-form-card" id="new-student-form-card-6">
                            <div className="new-student-form-card-contents">
                                <div className="new-student-form-card-logo" style={{backgroundImage: `url(./${this.state.logoName})`}}></div>
                                <div className="new-student-form-card-title">Thank you so much!</div>
                                <div className="new-student-form-card-subtitle">We'll get back to you soon.</div>
                            </div>
                            <div className="new-student-form-btn-wrapper">
                                <div className="new-student-form-btn first-card-btn" onClick={() => this.changeCard('last')}>close</div>
                            </div>
                        </div>
                    </div>
                </>
            )
        } else {
            return(
                <h5>Form no long valid. Please email {this.state.email}</h5>
            )
        }
    }
}

export default NewStudentFormWithSecurity